import {
  START_LOAD_STATIONS,
  SUCCESS_LOAD_STATIONS,
  ERROR_LOAD_STATIONS,
} from 'store/actions/stations'

const initialState = {
  spp: [],
  wpp: [],
  isLoading: false,
  isLoaded: false,
  error: null,
}
const stations = (state = initialState, action) => {
  switch (action.type) {
    case START_LOAD_STATIONS: {
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    }
    case SUCCESS_LOAD_STATIONS: {
      const {
        data: {spp, wpp},
      } = action
      return {
        ...state,
        spp: spp || [],
        wpp: wpp || [],
        isLoading: false,
        isLoaded: true,
        error: null,
      }
    }
    case ERROR_LOAD_STATIONS: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    }
    default:
      return state
  }
}

export default stations
